export enum AssignedUserAcknowledged {
  Acknowledged = 1,
}
